// User-related utility functions

/**
 * Returns the best display name for a user object.
 * Order: name, preferred_username, username, email, id
 * @param {object} user
 * @returns {string}
 */
export function getDisplayName(user) {
  if (!user) return '';
  return (
    user.name ||
    user.preferred_username ||
    user.username ||
    user.email ||
    user.id ||
    ''
  );
} 